import { fromJS } from 'immutable';
import { SET, INITIATE_CLOSE } from './constants';

export const createDefaultState = () =>
  fromJS({
    notification: null,
    isOpen: false
  });

export default function reducer(
  state = createDefaultState(),
  { type, payload }
) {
  switch (type) {
    case SET: {
      return state.set('notification', fromJS(payload)).set('isOpen', true);
    }
    case INITIATE_CLOSE: {
      return state.set('isOpen', false);
    }
    default:
      return state;
  }
}
